import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from './user.service';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class IsAdminGuard {
  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}
  async canActivate(): Promise<boolean> {
    const loginInfo = await firstValueFrom(this.userService.getCurrentLoginInfo(false));

    if (loginInfo?.isAdmin === true) {
      return true;
    }

    if (loginInfo) {
      alert('Login not allowed.');
    }

    const urlTree = this.userService.createLoginPageUrlTree(this.router, this.route);
    const serialized = this.router.serializeUrl(urlTree);

    if (/^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(serialized)) {
      this.document.location.href = serialized;
      return false;
    }

    const location = this.document.location;
    const origin = location.origin;
    const fullPath = location.pathname;

    const currentRouteUrl = this.router.url || '/';
    let appRoot = fullPath;

    if (appRoot.endsWith(currentRouteUrl)) {
      appRoot = appRoot.slice(0, appRoot.length - currentRouteUrl.length);
    }

    if (!appRoot.endsWith('/')) {
      appRoot += '/';
    }

    const relative = serialized.replace(/^\//, '');
    const finalUrl = origin + appRoot + relative;
    this.document.location.href = finalUrl;

    return false;
  }
}
